// src/live/components/LiveToastContainer.tsx
import React, { useState, useEffect, useCallback } from 'react';
import LiveToast, { LiveToastData } from './LiveToast';

// Global toast queue - can be accessed from anywhere
let toastQueue: LiveToastData[] = [];
let listeners: ((toasts: LiveToastData[]) => void)[] = [];

function notifyListeners() {
  listeners.forEach((listener) => listener([...toastQueue]));
}

export function showLiveToast(toast: Omit<LiveToastData, 'id'>) {
  const newToast: LiveToastData = {
    ...toast,
    id: `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
  };
  toastQueue = [...toastQueue, newToast];
  notifyListeners();
}

export function dismissLiveToast(id: string) {
  toastQueue = toastQueue.filter((t) => t.id !== id);
  notifyListeners();
}

export default function LiveToastContainer() {
  const [toasts, setToasts] = useState<LiveToastData[]>([]);

  useEffect(() => {
    const listener = (newToasts: LiveToastData[]) => {
      setToasts(newToasts);
    };
    listeners.push(listener);

    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  }, []);

  const handleDismiss = useCallback((id: string) => {
    dismissLiveToast(id);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-3">
      {toasts.map((toast) => (
        <LiveToast key={toast.id} toast={toast} onDismiss={handleDismiss} />
      ))}
    </div>
  );
}
